import React from "react";
import { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { RiskTagEnumToString } from "../../../shared/enums/take-five-risk-tag-enum";
import { RiskAssessmentMatrix } from "../../../shared/models/api/models";
import { getRiskAssessmentMatrix } from "../../../shared/services/railOperationalFormsApi";
import {
    TakeFiveFormState,
    takeFiveFormState as t
} from "./TakeFiveFormState";

const RiskConsequency = [
    {
        id: '1',
        HealthAndSafety: 'First aid treatment',
        EnvironmentAndHeritage: 'Limited damage to area of low significance',
        CommMedGovt: 'Public concern restricted to local complaints',
        LossOrDamage: 'A$0-15k'
    },
    {
        id: '2',
        HealthAndSafety: 'Medical treatment',
        EnvironmentAndHeritage: 'Minor short-term damage to environmental / heritage area',
        CommMedGovt: 'Minor, adverse local public or media attention and complaints',
        LossOrDamage: 'A$15k-150k'
    },
    {
        id: '3',
        HealthAndSafety: 'Classified injury (LTI or restricted workcase)',
        EnvironmentAndHeritage: 'Moderate effects on environment / heritage',
        CommMedGovt: 'Attention from media and / or heightened concern from community',
        LossOrDamage: 'A$150k-1.5m'
    },
    {
        id: '4',
        HealthAndSafety: 'Fatality or severe permanent disability',
        EnvironmentAndHeritage: 'Significant environmental / heritage damage',
        CommMedGovt: 'Significant adverse national media / public attention',
        LossOrDamage: 'A$1.5m-15m'
    },
    {
        id: '5',
        HealthAndSafety: 'Multiple fatalities / health effects to >50 persons',
        EnvironmentAndHeritage: 'Severe damage to environment / heritage with long-term effects',
        CommMedGovt: 'Serious public or media outcry',
        LossOrDamage: 'A$15-150m'
    },
];

const RiskLikelyhood = [
    {
        id: '5',
        Description: 'Expected to happen',
        Frequency: 'Occurs once a week'
    },
    {
        id: '4',
        Description: 'May easily happen',
        Frequency: 'Occurs once a month'
    },
    {
        id: '3',
        Description: 'May happen',
        Frequency: 'Occurs once every year'
    },
    {
        id: '2',
        Description: 'May happen sometime',
        Frequency: 'Occurs once every 10 years'
    },
    {
        id: '1',
        Description: 'May happen in extrem circumstances',
        Frequency: 'Occurs once every 100 years'
    },
];
interface RiskScoreProps {
    open: boolean;
    onClose: () => void;
}

export const RiskScore = (props: RiskScoreProps) => {
    const [selectedConsequencyIdId, setSelectedConsequencyId] = useState('');
    const [selectedLikelyhoodId, setSelectedLikelyhoodId] = useState('');
    const [riskAssessmentMatrix, setRiskAssessmentMatrix] = useState([] as RiskAssessmentMatrix[]);
    const [calculateRiskScore, setCalculateRiskScore] = useState(false);

    useEffect(() => {
        if (!riskAssessmentMatrix.length) {
            let mounted = true;
            const mount = async () => {
                const matrix = await getRiskAssessmentMatrix();
                setRiskAssessmentMatrix(matrix);
            };

            mount();
            return () => { mounted = false };
        }
    }, [selectedConsequencyIdId, selectedLikelyhoodId]);

    useEffect(() => {
        if (selectedConsequencyIdId && selectedLikelyhoodId && calculateRiskScore) {
            t.setState((s: TakeFiveFormState) => {
                s.form.riskAssessmentMatrix = riskAssessmentMatrix;
                const riskAssessment = riskAssessmentMatrix.filter(r => r.likelyhood === +selectedLikelyhoodId && r.consequency === +selectedConsequencyIdId);
                s.form.score = riskAssessment[0].score.toString();
                s.form.bGroundColor = riskAssessment[0].color;
                s.form.riskTag = RiskTagEnumToString(riskAssessment[0].tag);
            });

            // Close modal
            setCalculateRiskScore(false);
            props.onClose();
        }
    }, [calculateRiskScore, selectedConsequencyIdId, selectedLikelyhoodId, riskAssessmentMatrix]);

    const reset = () => {
        setSelectedConsequencyId('');
        setSelectedLikelyhoodId('');
    }

    return (
        <>
            <div className="tf-risks-list-container">
                <div className="risk-header">
                    Select consequency level
                </div>

                <div className="risks">
                    <div className="risks-item risks-item-common">
                        <div className="risk-label">
                            Health & Safety
                        </div>
                    </div>
                    <div className="risks-item risks-item-common">
                        <div className="risk-label">
                            Environment & Heritage
                        </div>
                    </div>
                    <div className="risks-item risks-item-common">
                        <div className="risk-label">
                            Community / Media / Goverment
                        </div>
                    </div>
                    <div className="risks-item risks-item-loss">
                        <div className="risk-label">
                            Loss / Damage
                        </div>
                    </div>
                </div>
            {RiskConsequency?.map((item) => (
                <div key={item.id} className={selectedConsequencyIdId === item.id ? `consequency-selected risks` : `consequency-non-selected risks` } onClick={() => setSelectedConsequencyId(item.id) }>
                    <div className="risks-item risks-item-common">
                        <div className="risk-value">
                            {item.HealthAndSafety}
                        </div>
                    </div>
                    <div className="risks-item risks-item-common">
                        <div className="risk-value">
                            {item.EnvironmentAndHeritage}
                        </div>
                    </div>
                    <div className="risks-item risks-item-common">
                        <div className="risk-value">
                            {item.CommMedGovt}
                        </div>
                    </div>
                    <div className="risks-item risks-item-loss">
                        <div className="risk-value">
                            {item.LossOrDamage}
                        </div>
                    </div>
                </div>
            ))}

            <div className="risk-header">
                Select likelihood level
            </div>

                <div className="risks">
                    <div className="risks-item risk-likelyhood">
                        <div className="risk-label">
                            Description
                        </div>
                    </div>
                    <div className="risks-item risk-likelyhood">
                        <div className="risk-label">
                            Frequency at location
                        </div>
                    </div>
                </div>
            {RiskLikelyhood?.map((item) => (
                <div key={item.id} className={selectedLikelyhoodId === item.id ? `consequency-selected risks` : `consequency-non-selected risks`} onClick={() => setSelectedLikelyhoodId(item.id)}>
                    <div className="risks">
                        <div className="risks-item risk-likelyhood">
                            <div className="risk-value">
                                {item.Description}
                            </div>
                        </div>
                        <div className="risks-item risk-likelyhood">
                            <div className="risk-value">
                                {item.Frequency}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            </div>
            <div className="submit btns-container">
                <Button className="btn-primary" onClick={() => { setCalculateRiskScore(true) }}>Get Risk Score</Button>
                <Button className="btn-primary btn-spacing" onClick={() => { reset(), props.onClose() }}>Cancel</Button>
            </div>
        </>
    );
}